import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { AnnualStatement } from "interface/accounting";
import { ICON_NAMES } from "utils/constant";

interface AnnualStatementMobileListProps {
	items: AnnualStatement[];
	loading: boolean;
	onOpenPdf: (item: AnnualStatement) => void;
	onLoadMore: () => void;
}

const getStatusClassName = (item: AnnualStatement) => {
	return item.reportGuid
		? "annual-statement-list-card--status-green"
		: "annual-statement-list-card--status-yellow";
};

const AnnualStatementMobileList: FC<AnnualStatementMobileListProps> = ({
	items,
	loading,
	onOpenPdf,
	onLoadMore,
}) => {
	const { t } = useTranslation();
	const empty = useMemo(() => !loading && items.length === 0, [items.length, loading]);

	const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
		const target = event.currentTarget;
		const remaining = target.scrollHeight - target.scrollTop - target.clientHeight;
		if (remaining < 200) {
			onLoadMore();
		}
	};

	return (
		<div className="annual-statement-list-mobile" onScroll={handleScroll}>
			{empty && <div className="annual-statement-list-mobile-empty">{t("NoRows")}</div>}

			{items.map((item, itemIndex) => {
				const itemKey = `${item.year}-${item.customerBusinessRegisterNumber ?? "nobusiness"}-${itemIndex}`;

				return (
					<div
						key={itemKey}
						className={`annual-statement-list-card ${getStatusClassName(item)}`}
					>
						<div className="annual-statement-list-card-header">
							<div className="annual-statement-list-card-note">{item.year || "-"}</div>
							<div className="annual-statement-list-card-name">{item.customerName || "-"}</div>
							<div className="annual-statement-list-card-org">
								{item.customerBusinessRegisterNumber || "-"}
							</div>
						</div>

						<div className="annual-statement-list-card-body">
							<div>
								<span>År</span>
								<strong>{item.year || "-"}</strong>
							</div>
							<div>
								<span>{t("OrgNumber")}</span>
								<strong>{item.customerBusinessRegisterNumber || "-"}</strong>
							</div>
							<div>
								<span>{t("VesselName")}</span>
								<strong>{item.customerName || "-"}</strong>
							</div>
							<div>
								<span>{t("VesselOwner")}</span>
								<strong>{item.vesselOwnerName || "-"}</strong>
							</div>
						</div>

						<div className="annual-statement-list-card-actions">
							<button
								type="button"
								className="annual-statement-list-icon-btn"
								onClick={() => onOpenPdf(item)}
								title={t("Download")}
								disabled={!item.reportGuid}
							>
								<img src={`/icon/${ICON_NAMES.Download}.svg`} alt={t("Download")} />
							</button>
						</div>
					</div>
				);
			})}

			{loading && <div className="annual-statement-list-mobile-loading">{t("Loading")}</div>}
		</div>
	);
};

export default AnnualStatementMobileList;